module.exports = __webpack_public_path__ + "img/mail_icon.ffc6adbf.svg";